/* wh1-pages.js : WILDHORN DARK, pages builder. The preview page scripts (help, contact, contact-us,
   manage-subscription, track-your-order) + Shopify form wiring. GENERATED by tools/build_pages.py.
   Loaded with defer after wh1-shell.js (window.WH). Each block only runs on its own page. */

/* ===== help (pages/help.html) ===== */
(function () {
  if (!document.querySelector('#main.page-help')) return;
/* Contact form: same submission as the PowerfulForm app (form 155702). The app sends a
   FormData with the field names + time_zone via fetch() to the form action, then shows its
   afterSubmit message and clears the form. Error texts are the app's own errorMessage config. */
document.addEventListener('DOMContentLoaded', function () {
  var d = document, f = d.getElementById('hlp-form'); if (!f) return;
  var ok = d.getElementById('hlp-ok'), ko = d.getElementById('hlp-ko'), btn = f.querySelector('button[type="submit"]');
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var req = [].slice.call(f.querySelectorAll('[required]'));
  var keyLabel = {};
  req.forEach(function (i) { keyLabel[i.name] = i.getAttribute('data-label'); });
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  function check(inp) {
    var fl = inp.closest('.field'), v = inp.value.trim(), err = fl.querySelector('.hlp-err'), msg = '';
    if (inp.required && !v) msg = cap(inp.getAttribute('data-label')) + ' is required';
    else if (inp.type === 'email' && !EMAIL.test(v)) msg = 'Email address is invalid';
    fl.classList.toggle('is-bad', !!msg); inp.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (err) err.textContent = msg;
    return !msg;
  }
  req.forEach(function (i) {
    i.addEventListener('blur', function () { if (i.value.trim() || i.closest('.field').classList.contains('is-bad')) check(i); });
    i.addEventListener('input', function () { if (i.closest('.field').classList.contains('is-bad')) check(i); });
  });
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    ok.hidden = true; ko.hidden = true;
    var first = null;
    req.forEach(function (i) { if (!check(i) && !first) first = i; });
    if (first) { first.focus(); return; }
    f.querySelector('[name="page[title]"]').value = d.title;
    f.querySelector('[name="page[href]"]').value = location.href;
    f.querySelector('[name="_keyLabel"]').value = JSON.stringify(keyLabel);
    var fd = new FormData(f);
    try { fd.append('time_zone', Intl.DateTimeFormat().resolvedOptions().timeZone); } catch (x) {}
    f.classList.add('is-sending'); btn.disabled = true;
    fetch(f.getAttribute('action'), { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        if (j && j.errors) {
          var out = [];
          Object.keys(j.errors).forEach(function (k) {
            var m = j.errors[k]; m = Array.isArray(m) ? m.join(' ') : String(m);
            out.push((keyLabel[k] ? keyLabel[k] + ': ' : '') + m);
          });
          var se = new Error(out.join(' ')); se.srv = true; throw se;
        }
        f.reset(); ok.hidden = false;
        try { ok.focus({ preventScroll: true }); } catch (x) { ok.focus(); }
        ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function (er) {
        var m = er && er.srv && er.message ? er.message : 'Something went wrong, please try again';
        ko.textContent = m; ko.hidden = false;
      })
      .then(function () { f.classList.remove('is-sending'); btn.disabled = false; });
  });
});
})();

/* ===== contact (pages/contact.html) ===== */
(function () {
  if (!document.querySelector('#main.page-contact')) return;

})();

/* contact (Shopify only): real {% form 'contact' %}. Same validation toast as the preview, then the
   form posts for real; after the reload the result is shown with the same toast. */
(function () {
  var d = document, f = d.getElementById('ContactForm');
  if (!f || !d.querySelector('#main.page-contact')) return;
  d.addEventListener('DOMContentLoaded', function () {
    if (!window.WH) return;
    WH.validateForm(f);
    var st = f.querySelector('[data-wh1-state]');
    if (st) WH.toast(st.getAttribute('data-msg') || '', st.getAttribute('data-wh1-state') === 'error' ? 'error' : undefined);
  });
})();

/* ===== contact-us (pages/contact-us.html) ===== */
(function () {
  if (!document.querySelector('#main.page-contact-us')) return;

})();

/* PowerfulForm (Globo) app form inside the pages (help, contact-us): the app renders and submits it,
   same embed as the live pages. Cosmetic only: the last word of its title gets the site's accent
   colour, like every title of the site ("Contact <span>us</span>"). */
(function () {
  var d = document;
  function accent() {
    [].slice.call(d.querySelectorAll('.wh1-main .globo-formbuilder .globo-heading')).forEach(function (h) {
      if (h.children.length) return;
      var t = (h.textContent || '').trim(), i = t.lastIndexOf(' ');
      if (i < 1) return;
      h.textContent = t.slice(0, i + 1);
      var s = d.createElement('span'); s.textContent = t.slice(i + 1); h.appendChild(s);
    });
  }
  function start() {
    var boxes = d.querySelectorAll('.wh1-main .globo-formbuilder'); if (!boxes.length) return;
    accent();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(accent);
    [].slice.call(boxes).forEach(function (b) { mo.observe(b, { childList: true, subtree: true }); });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

/* ===== manage (pages/manage-subscription.html) ===== */
(function () {
  if (!document.querySelector('#main.page-manage')) return;
/* Same destination as the live login form: Loop magic link for this email, new tab. */
(function () {
  var f = document.getElementById('lf'); if (!f) return;
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var bad = [].slice.call(f.querySelectorAll('input[required]')).filter(function (i) { return !i.checkValidity() || !i.value.trim(); })[0];
    if (bad) { if (window.WH && WH.toast) WH.toast(bad.type === 'email' ? 'Please enter a valid email.' : 'Please fill in this field.', 'error'); bad.focus(); return; }
    var email = document.getElementById('em').value.trim();
    window.location.href = new URL(f.getAttribute('action'), location.origin).href + '?email=' + encodeURIComponent(email);
  });
})();
})();

/* ===== track (apps/parcelpanel.html) ===== */
(function () {
  if (!document.querySelector('#main.page-track')) return;
(function () {
  /* Real ParcelPanel lookup: same public endpoint the live widget on trywildhorn.com/apps/parcelpanel calls
     (CORS *, no auth for number or order+email lookups). 404 = not found. */
  var API = 'https://pp-proxy.parcelwill.com/api/v2/tracking-info';
  var SHOP = (document.getElementById('trk-result') || {getAttribute: function () {}}).getAttribute('data-shop') || '0wn9dq-kg.myshopify.com';
  var LIVE = location.origin + '/apps/parcelpanel';
  var T = {
    order: 'Order', status: 'Status', shipment: 'Shipment', carrier: 'Carrier', product: 'Product',
    shipping_to: 'Shipping To', current_location: 'Current Location', tracking_number: 'Tracking Number',
    expected: 'Estimated Delivery Date', lm_carrier: 'Last-mile Carrier', lm_number: 'Last-mile Tracking Number',
    not_found: 'Could Not Find Order', not_shipped: 'These items have not yet shipped.',
    waiting: 'Waiting for carrier to update tracking information, please try again later.',
    enter_order: 'Please enter your order number', enter_email: 'Please enter your email or phone number',
    enter_nums: 'Please enter your tracking number', track_order: 'Track Your Order'
  };
  var NAMES = {1: 'Pending', 8: 'Info Received', 2: 'In Transit', 3: 'Out for Delivery', 9: 'Ready for Pickup', 4: 'Delivered', 7: 'Exception', 6: 'Failed Attempt', 5: 'Expired', 1001: 'Ordered', 1100: 'Order Ready'};
  var ICONS = [
    '<path d="M6 7.5h12l-1 12.5H7L6 7.5z"/><path d="M9 7.5a3 3 0 0 1 6 0"/>',
    '<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4v-9z"/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9"/>',
    '<path d="M2.5 6.5h11v9.5h-11zM13.5 9.5h4l3.5 3.5V16h-7.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/>',
    '<path d="M3.5 11.5 12 4.5l8.5 7"/><path d="M5.5 10v10h13V10"/><path d="m9.5 14.8 2 2 3.5-4"/>'
  ];
  var STEPS = [[1001, 'Ordered'], [1100, 'Order Ready'], [2, 'In Transit'], [3, 'Out for Delivery'], [4, 'Delivered']];
  var d = document, box = d.getElementById('trk-result'), panel = d.getElementById('trk-panel');
  var state = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
  function scrub(s) { return String(s || '').replace(/\b(china|aliexpress)\b/gi, '').replace(/\s*,\s*,/g, ',').replace(/^[\s,]+|[\s,]+$/g, ''); }
  /* minorfix-2709 privacy: ParcelPanel sends the full delivery address ("street, [unit], city, State ZIP, Country") and anyone
     holding a tracking number can open this page, so "Shipping To" keeps only city, state/province and country.
     r2: with 3+ segments the first one is the street line (never shown); a city written inside the postcode segment
     ("London NW1 6XE", "Madrid 28013", "75002 Paris") is used as the city; street-like words are never shown. */
  function shipTo(v) {
    var p = String(v || '').split(',').map(function (x) { return x.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (!p.length) return '';
    var ZIP = /\s*\b(\d{5}(-\d{4})?|\d{4}|\d{6}|[A-Z]\d[A-Z] ?\d[A-Z]\d|[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;
    var ZIP0 = /^(\d{4,6}|[A-Z]\d[A-Z] ?\d[A-Z]\d)\s+(?=[^\d\s])/i;
    var UNIT = /^(apt|apartment|unit|suite|ste|fl|floor|bldg|building|room|rm|flat|lot|p\.? ?o\.? box|#)(\b|\s|\d|$)/i;
    var STREET = /(^|\s)(street|st|avenue|ave|road|rd|drive|dr|lane|ln|boulevard|blvd|way|court|ct|place|pl|circle|cir|terrace|parkway|pkwy|highway|hwy|trail|trl|square|sq|crescent|cres|close|alley|loop|pike|route|rte|expressway|expy|freeway|fwy|plaza|plz)\.?(\s+(n|s|e|w|ne|nw|se|sw|north|south|east|west))?$|^(calle|carrer|camino|carretera|paseo|avenida|av|rue|avenue|boulevard|bd|chemin|impasse|via|viale|corso|piazza|rua|travessa|largo)\b|(strasse|straße|str\.|weg|gasse|allee|laan|straat|gracht|vej|gatan|gata|veien)$/i;
    var REGION = /^(alabama|alaska|arizona|arkansas|california|colorado|connecticut|delaware|district of columbia|florida|georgia|hawaii|idaho|illinois|indiana|iowa|kansas|kentucky|louisiana|maine|maryland|massachusetts|michigan|minnesota|mississippi|missouri|montana|nebraska|nevada|new hampshire|new jersey|new mexico|new york|north carolina|north dakota|ohio|oklahoma|oregon|pennsylvania|rhode island|south carolina|south dakota|tennessee|texas|utah|vermont|virginia|washington|west virginia|wisconsin|wyoming|puerto rico|guam|alberta|british columbia|manitoba|new brunswick|newfoundland and labrador|nova scotia|ontario|prince edward island|quebec|québec|saskatchewan|yukon|nunavut|northwest territories)$/i;
    function region(x) { return /^[A-Z]{2,3}$/.test(x) || REGION.test(x); }
    function ok(x) { return x && !/\d/.test(x) && !UNIT.test(x) && !STREET.test(x); }
    var last = p.length - 1, si = -1, rest = '', out, i, m;
    for (i = last; i >= 0 && si < 0; i--) {
      if (UNIT.test(p[i])) continue;
      if (ZIP.test(p[i])) m = p[i].replace(ZIP, '').trim();
      else if (i > 0 && ZIP0.test(p[i])) m = p[i].replace(ZIP0, '').trim();
      else continue;
      if (i === 0 && m && !region(m)) break; /* a postcode-looking number inside the street line: no postcode segment */
      si = i; rest = m;
    }
    var country = si > -1 && si < last ? p[last] : '';
    if (si > -1) {
      var f = p.length === 2 ? 0 : 1; /* 'City, ST zip' (no street line, e.g. the ParcelPanel demo) may use segment 0 */
      var c1 = si - 1 >= f ? p[si - 1] : '', c2 = si - 2 >= f ? p[si - 2] : '';
      if (rest && !region(rest)) out = [rest, country];
      else if (rest) out = [c1, rest, country];
      else if (region(c1)) out = [c2, c1, country];
      else out = [c1, country];
    } else {
      out = p.slice(p.length > 2 ? 1 : last).slice(-2);
      if (p.length > 3 && region(p[last - 1])) out = [p[last - 2]].concat(out);
    }
    return out.filter(function (x, k) { return ok(x) && out.indexOf(x) === k; }).join(', ');
  }
  function svg(p, w) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (w || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';

  function url(params) {
    var u = new URL(API);
    Object.keys(params).forEach(function (k) { u.searchParams.set(k, params[k]); });
    u.searchParams.set('shop', SHOP); u.searchParams.set('lang', 'en'); u.searchParams.set('country', 'US');
    return u.toString();
  }
  function liveUrl(params) {
    var u = new URL(LIVE);
    if (params.track_number) u.searchParams.set('nums', params.track_number);
    return u.toString();
  }
  function show(html) { panel.innerHTML = html; box.hidden = false; }
  function scrollToResult() { try { box.scrollIntoView({behavior: 'smooth', block: 'start'}); } catch (e) { box.scrollIntoView(); } }

  function lookup(params, opts) {
    opts = opts || {};
    var btn = opts.btn;
    if (btn) btn.classList.add('is-loading');
    show('<div class="trk-skel" aria-label="Loading"><i></i><i></i><i></i></div>');
    scrollToResult();
    var ctrl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    fetch(url(params), {headers: {Accept: 'application/json'}, credentials: 'omit', referrerPolicy: 'no-referrer', signal: ctrl ? ctrl.signal : undefined})
      .then(function (r) {
        if (r.status === 404) return {nf: true};
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var data = j && j.data;
        if (j.nf || !data || !Array.isArray(data.tracking) || !data.tracking.length) { notFound(params); return; }
        state = {data: data, params: params, demo: !!opts.demo, sel: 0};
        if (params.track_number) {
          var i = data.tracking.findIndex(function (t) { return t.track_number === data.track_number; });
          state.sel = i > 0 ? i : 0;
        }
        render();
      })
      .catch(function () { failed(params); })
      .then(function () { clearTimeout(to); if (btn) btn.classList.remove('is-loading'); });
  }

  function notFound(params) {
    show('<div class="card trk-empty">' + svg('<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M8.5 8.5l5 5M13.5 8.5l-5 5"/>', 1.8) +
      '<h2 class="h3">' + esc(T.not_found) + '</h2>' +
      '<p>Questions? Reach us anytime through the <a href="/pages/help">contact page</a> and we will locate your package for you.</p></div>');
  }
  function failed(params) {
    show('<div class="card trk-empty">' + svg('<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.4v.1"/>', 1.8) +
      '<h2 class="h3">' + esc(T.track_order) + '</h2>' +
      '<div class="cta-row"><a class="btn" href="' + esc(liveUrl(params)) + '" target="_blank" rel="noopener">' + esc(T.track) + ARROW + '</a></div></div>');
  }
  T.track = 'Track';

  function stepIndex(s, t) {
    if (s === 4) return 4;
    if (s === 3 || s === 9) return 3;
    if (s === 2 || s === 5 || s === 6 || s === 7) return 2;
    if (s === 1 || s === 8 || s === 1100) return 1;
    if (s === 1001) return 0;
    return t.track_number ? 1 : 0;
  }

  function render() {
    var data = state.data, list = data.tracking, t = list[state.sel] || list[0];
    var s = +((t.status_num && t.status_num.status) || t.stausDataNum || 0);
    var events = (Array.isArray(t.trackinfo) ? t.trackinfo : []).filter(function (e) { return e && (e.StatusDescription || e.Details); });
    var shipped = !!t.track_number || events.length > 0;
    if (!shipped && !s) s = t.order_fulfill_time ? 1100 : 1001;
    var idx = stepIndex(s, t);
    var name = (t.status_num && t.status_num.name) || NAMES[s] || t.status || NAMES[STEPS[idx][0]];
    /* qafix-2609: the bar follows the status shown in the heading (ParcelPanel can send status_num.status 2 with name "Info Received") */
    var sn = null; for (var nk in NAMES) { if (String(NAMES[nk]).toLowerCase() === String(name).trim().toLowerCase()) { sn = +nk; break; } }
    if (sn !== null && sn !== s) { s = sn; idx = stepIndex(s, t); }
    var warn = s === 5 || s === 6 || s === 7;
    var delivered = s === 4;
    var nodes = t.status_node || {};

    var loc = '';
    try { var mp = data.map_api && data.map_api[String(state.sel)]; loc = mp && mp.map_info && mp.map_info[0] && mp.map_info[0].Details; } catch (e) {}
    if (!loc) { for (var k = 0; k < events.length; k++) { if (events[k].DetailsMap) { loc = events[k].DetailsMap; break; } } }
    loc = scrub(loc);

    var eta = t.ScheduledDeliveryDate || '';
    var edd = t.edd || {};
    if (!eta && edd) {
      var a = edd.start || edd.min || edd.from || edd.date || edd.edd || '', b = edd.end || edd.max || edd.to || '';
      eta = a && b && a !== b ? a + ' to ' + b : (a || b || '');
    }
    if (!eta && +t.shipping_time_show === 1 && t.shipping_time_con) eta = t.shipping_time_con;

    var ref = data.order ? T.order + ' ' + (String(data.order).charAt(0) === '#' ? '' : '#') + data.order
      : (state.params.track_number ? T.tracking_number + ' ' + state.params.track_number : '');

    var h = '';
    if (state.demo) h += '<p class="trk-chip">Demo</p>';
    h += '<div class="trk-head' + (eta ? ' has-eta' : '') + (delivered ? ' is-delivered' : '') + (warn ? ' is-warn' : '') + '">';
    h += '<div class="card trk-status"><p class="kicker">' + esc(ref) + '</p>';
    h += '<p class="trk-status__name" role="status"><span class="trk-pulse" aria-hidden="true"></span>' + esc(name) + '</p>';
    if (loc) h += '<p class="trk-loc">' + esc(T.current_location) + ': <b>' + esc(loc) + '</b></p>';
    if (list.length > 1) {
      h += '<div class="trk-ship" role="group" aria-label="' + esc(T.shipment) + '">';
      list.forEach(function (x, i) { h += '<button type="button" data-ship="' + i + '" aria-pressed="' + (i === state.sel) + '">' + esc(T.shipment) + ' ' + (i + 1) + '</button>'; });
      h += '</div>';
    }
    h += '</div>';
    if (eta) h += '<div class="card card--ember trk-eta"><p class="label">' + esc(T.expected) + '</p><p class="trk-eta__d">' + esc(eta) + '</p></div>';
    h += '</div>';

    h += '<div class="' + (delivered ? 'is-delivered' : '') + (warn ? ' is-warn' : '') + '"><ol class="trk-bar" aria-label="' + esc(T.status) + '"><span class="trk-bar__track" aria-hidden="true"><span class="trk-bar__fill" id="trk-fill"></span></span>';
    STEPS.forEach(function (st, i) {
      var label = st[1];
      if (i === 3 && s === 9) label = NAMES[9];
      if (i === 1 && s === 8) label = NAMES[8];
      var cls = i < idx ? 'is-done' : (i === idx ? (idx === 4 ? 'is-done is-now' : 'is-now') : '');
      var dt = (nodes[st[0]] && nodes[st[0]].Date) || '';
      if (!dt && i === 3 && nodes[9]) dt = nodes[9].Date;
      if (i === 1 && s === 8 && nodes[8] && nodes[8].Date) dt = nodes[8].Date;
      if (i > idx) dt = ''; /* qafix-2609: no date under a step not reached yet */
      h += '<li class="' + cls + '"' + (i === idx ? ' aria-current="step"' : '') + '><span class="trk-bar__dot">' + svg(ICONS[i]) + '</span><b>' + esc(label) + '</b><span class="d">' + esc(dt) + '</span></li>';
    });
    h += '</ol></div>';

    h += '<div class="trk-grid"><div class="card trk-log"><p class="label">' + esc(T.status) + '</p>';
    if (events.length) {
      h += '<ol class="trk-tl">';
      events.forEach(function (e) {
        var desc = scrub(e.StatusDescription || e.Details), where = scrub(e.DetailsMap || '');
        if (where && desc.toUpperCase().indexOf(where.toUpperCase()) > -1) where = '';
        h += '<li><time>' + esc(e.Date) + '</time><p>' + esc(desc) + '</p>' + (where ? '<span class="loc">' + esc(where) + '</span>' : '') + '</li>';
      });
      h += '</ol>';
    } else {
      h += '<p class="trk-msg">' + esc(shipped ? T.waiting : T.not_shipped) + '</p>';
    }
    h += '</div><aside class="trk-side" aria-label="' + esc(T.shipment) + '">';

    var lm = t.last_mile_carrier;
    if (t.carrier_name || (lm && lm.name)) {
      h += '<div class="card">';
      if (t.carrier_name) {
        h += '<p class="label">' + esc(T.carrier) + '</p><div class="trk-carrier">' + (t.img ? '<img src="' + esc(t.img) + '" alt="" loading="lazy">' : '') + '<div><b>' + esc(t.carrier_name) + '</b></div></div>';
      }
      if (lm && lm.name) {
        h += '<p class="label"' + (t.carrier_name ? ' style="margin-top:16px"' : '') + '>' + esc(T.lm_carrier) + '</p><div class="trk-carrier">' + (lm.logo_url ? '<img src="' + esc(lm.logo_url) + '" alt="" loading="lazy">' : '') + '<div><b>' + esc(lm.name) + '</b>';
        if (lm.tracking_number) h += lm.redirect_link ? '<a href="' + esc(lm.redirect_link) + '" target="_blank" rel="noopener" aria-label="' + esc(T.lm_number) + '">' + esc(lm.tracking_number) + '</a>' : '<span>' + esc(lm.tracking_number) + '</span>';
        h += '</div></div>';
      }
      h += '</div>';
    }
    var to = shipTo(t.shipping_map && t.shipping_map.location); /* minorfix-2709: city, state, country only */
    if (to) h += '<div class="card"><p class="label">' + esc(T.shipping_to) + '</p><p class="trk-val">' + esc(to) + '</p></div>';
    var prods = Array.isArray(t.products) ? t.products : [];
    if (state.demo) prods = [{title: 'Wild Bison', quantity: 2, image_url: box.getAttribute('data-demo-img')}];
    if (prods.length) {
      h += '<div class="card"><p class="label">' + esc(T.product) + '</p>';
      prods.forEach(function (p) {
        h += '<div class="trk-prod"><span class="trk-prod__img">' + (p.image_url ? '<img src="' + esc(p.image_url) + '" alt="" loading="lazy">' : '') + (p.quantity ? '<i>' + esc(p.quantity) + '</i>' : '') + '</span><div><b>' + esc(p.title) + '</b>' + (p.variant_title ? '<span>' + esc(p.variant_title) + '</span>' : '') + '</div></div>';
      });
      h += '</div>';
    }
    h += '</aside></div>';

    show(h);
    var fill = d.getElementById('trk-fill');
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (fill) fill.style.width = (idx / 4 * 100) + '%'; }); });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-ship]'), function (b) {
      b.addEventListener('click', function () { state.sel = +b.getAttribute('data-ship'); render(); });
    });
  }

  function setErr(input, msg) {
    var e = d.getElementById(input.id + '-err');
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    if (e) e.textContent = msg || '';
    return !msg;
  }
  function setQuery(q) {
    try {
      var sp = new URLSearchParams(location.search);
      ['nums', 'track_number', 'order', 'email', 'demo'].forEach(function (k) { sp.delete(k); });
      new URLSearchParams(q || '').forEach(function (v, k) { sp.set(k, v); });
      var s = sp.toString();
      history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
    } catch (e) {}
  }

  var fo = d.getElementById('trk-f-order'), fn = d.getElementById('trk-f-nums');
  var iO = d.getElementById('trk-order'), iE = d.getElementById('trk-email'), iN = d.getElementById('trk-nums');
  [iO, iE, iN].forEach(function (i) { i.addEventListener('input', function () { setErr(i, ''); }); });

  fo.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var o = iO.value.trim(), e = iE.value.trim();
    var ok = setErr(iO, o ? '' : T.enter_order);
    ok = setErr(iE, e ? '' : T.enter_email) && ok;
    if (!ok) { (o ? iE : iO).focus(); return; }
    setQuery('');
    lookup({order: o, email: e}, {btn: fo.querySelector('button')});
  });
  fn.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var n = iN.value.trim().replace(/\s+/g, '');
    if (!setErr(iN, n ? '' : T.enter_nums)) { iN.focus(); return; }
    setQuery('nums=' + encodeURIComponent(n));
    lookup({track_number: n}, {btn: fn.querySelector('button')});
  });

  /* Deep links, same params as the live widget: ?nums= / ?track_number= / ?order=&email= ; ?demo=1 = ParcelPanel sample shipment */
  var sp = new URLSearchParams(location.search);
  var n0 = sp.get('nums') || sp.get('track_number');
  if (sp.get('demo') === '1') lookup({track_number: '1234'}, {demo: true});
  else if (n0) { iN.value = n0; lookup({track_number: n0.replace(/\s+/g, '')}, {btn: fn.querySelector('button')}); }
  else if (sp.get('order') && sp.get('email')) { iO.value = sp.get('order'); iE.value = sp.get('email'); setQuery(''); lookup({order: iO.value.trim(), email: iE.value.trim()}, {btn: fo.querySelector('button')}); }
})();
})();
